module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/3_4.40f9a9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/3_4.jpg
// module id = pQlk
// module chunks = 0